import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCh = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-ch",
	viewBox: "0 0 640 480",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		strokeWidth: "1pt",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "red",
			d: "M0 0h640v480H0z"
		}), /* @__PURE__ */ _jsxs("g", {
			fill: "#fff",
			children: [/* @__PURE__ */ _jsx("path", { d: "M170 195h300v90H170z" }), /* @__PURE__ */ _jsx("path", { d: "M275 90h90v300h-90z" })]
		})]
	})
});
export default SvgCh;
